<label class="font-weight-light f-15 mb-1">{{ 'timetrackingpanel.timetracking' | trans }}</label>
<div class="form-group border rounded p-2">
  <div class="row mb-2">
    <div class="col">
      <small class="d-block text-muted">{{ 'timetrackingpanel.estimate' | trans }}</small>
      <span class="d-flex align-items-center cursor-default">
        <strong>{{ currentEstimateMinutes() !== undefined ? minutesToHours(currentEstimateMinutes()) + 'h' :
          ('timetrackingpanel.notset' | trans)
          }}</strong>
        <span matTooltip="{{ 'projectlist.edit' | trans }}" matTooltipPosition="left" matTooltipShowDelay="500"
          class="material-icons align-middle lh-20 p-0 w-20 h-20 f-16 cursor-pointer ml-1" title="Set estimate"
          (click)="toggleEstimatePanel()">edit</span>
      </span>
    </div>
    <div class="col">
      <small class="d-block text-muted cursor-default">{{ 'timetrackingpanel.logged' | trans }}</small>
      <span class="d-flex align-items-center cursor-default">
        <strong>{{ minutesToHours(loggedMinutes()) }}h</strong>
        <span matTooltip="{{ 'timetrackingpanel.history' | trans }}" matTooltipPosition="left" matTooltipShowDelay="500"
          class="material-icons align-middle lh-20 p-0 w-20 h-20 f-16 cursor-pointer ml-1" title="Show time log"
          (click)="toggleLogPanel()">history</span>
      </span>
    </div>
    <div class="col cursor-default">
      <small class="d-block text-muted">{{ 'timetrackingpanel.remaining' | trans }}</small>
      <strong>{{ remainingMinutes() !== undefined ? minutesToHours(remainingMinutes()) + 'h' : '—' }}</strong>
    </div>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger text-center cursor-default p-2 ml-0 mr-0 w-100 mb-2">
    <small>{{ errorMessage }}</small>
  </div>

  <!-- Add / change estimate, and its history — toggled by the edit icon above -->
  <div *ngIf="estimatePanelOpen">
    <div class="row align-items-end mb-2">
      <div class="col-6">
        <small class="d-block text-muted cursor-default">{{ 'timetrackingpanel.newestimate' | trans }}</small>
        <input type="number" min="0" step="0.25" class="form-control form-control-sm" [(ngModel)]="newEstimateHours"
          name="newEstimateHours" />
      </div>
      <div class="col-6">
        <small class="d-block text-muted cursor-default">{{ 'timetrackingpanel.commentoptional' | trans }}</small>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="newEstimateComment"
          name="newEstimateComment" placeholder="Why the estimate changed" />
      </div>
      <div class="col-12">
        <button type="button" class="btn btn-sm btn-outline-secondary w-100 mt-2" (click)="addEstimate()">{{
          'timetrackingpanel.setestimate' | trans }}</button>
      </div>
    </div>
    <ul *ngIf="estimates.length" class="list-unstyled small text-muted mb-2 cursor-default">
      <li *ngFor="let e of estimates" class="list-unstyled">
        {{ e.madeAt | date:'short' }} — {{ minutesToHours(e.minutes) }}h
        <span *ngIf="e.comment"> · {{ e.comment }}</span>
      </li>
    </ul>
  </div>

  <!-- Log time: the form always stays visible, only the log below is toggled -->
  <div class="row align-items-end mb-2">
    <div class="col-5">
      <small class="d-block text-muted cursor-default">{{ 'timetrackingpanel.date' | trans }}</small>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="newEntryDate" name="newEntryDate" />
    </div>
    <div class="col-2">
      <small class="d-block text-muted cursor-default">{{ 'timetrackingpanel.hours' | trans }}</small>
      <input type="number" min="0" step="0.25" class="form-control form-control-sm" [(ngModel)]="newEntryHours"
        name="newEntryHours" />
    </div>
    <div class="col-5">
      <small class="d-block text-muted cursor-default">{{ 'timetrackingpanel.noteoptional' | trans }}</small>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="newEntryNote" name="newEntryNote" />
    </div>
    <div class="col-12">
      <button type="button" class="btn btn-sm btn-outline-secondary w-100 mt-2" (click)="logTime()">{{
        'timetrackingpanel.logtime' | trans }}</button>
    </div>
  </div>

  <div *ngIf="logPanelOpen">
    <div *ngIf="loading" class="small text-muted">{{ 'timetrackingpanel.loadingtimeentries' | trans }}</div>
    <ul *ngIf="!loading && timeEntries.length" class="list-unstyled small mb-0">
      <li *ngFor="let entry of timeEntries"
        class="d-flex justify-content-between align-items-center cursor-default mb-2 ml-2">
        <span>
          {{ entry.workDate | date:'mediumDate' }} — {{ minutesToHours(entry.minutes) }}h
          <span *ngIf="entry.note"> · {{ entry.note }}</span>
        </span>
        <button *ngIf="isMyTimeEntry(entry)" type="button" class="btn btn-sm  p-0 pl-2 pr-2"
          (click)="deleteTimeEntry(entry)">
          <p class="btn-text">{{ 'timetrackingpanel.remove' | trans }}</p>
        </button>
      </li>
    </ul>
    <div *ngIf="!loading && !timeEntries.length" class="small text-muted">{{ 'timetrackingpanel.notimelogged' |
      trans }}</div>
  </div>
</div>